import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const HypotheticalReturn = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormFields>();

  return (
    <Controller
      control={control}
      name="accountPortfolio.assetAllocationList.0.hypotheticalReturn"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          label="Straight-line Projected Return"
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          formVariant={
            errors.accountPortfolio?.assetAllocationList?.[0]?.hypotheticalReturn && 'error'
          }
          helperText={
            errors.accountPortfolio?.assetAllocationList?.[0]?.hypotheticalReturn?.message
          }
        />
      )}
    />
  );
};
